export const mockProgressData = [
  {
    color: '#B1CBFF',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'pmr_validation_state_draft',
    percentage: 0,
    trailColor: '#F1F3F8',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 'PMI_DRAFT',
    elementState: 2,
    containerClass: 'RadialHeaderList_radialFilterComponentContainer__2xTWU',
    disableStrokeColor: '#F1F3F8',
  },
  {
    color: '#82ABFF',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: 'sent_to',
    label: 'pmr_validation_state_chief_of_operations',
    percentage: 0,
    trailColor: '#F1F3F8',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 'PMI_COO',
    elementState: 2,
    containerClass: 'RadialHeaderList_radialFilterComponentContainer__2xTWU',
    disableStrokeColor: '#F1F3F8',
  },
  {
    color: '#538CFF',
    value: null,
    valueSuffix: 'menu_projects',
    supLabelTranslation: 'sent_to',
    label: 'pmr_validation_state_chief_of_divisions',
    percentage: 0,
    trailColor: '#F1F3F8',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 'PMI_DC',
    elementState: 2,
    containerClass: 'RadialHeaderList_radialFilterComponentContainer__2xTWU',
    disableStrokeColor: '#F1F3F8',
  },
  {
    color: '#236BFF',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: 'sent_to',
    label: 'pmr_validation_state_representative',
    percentage: 0,
    trailColor: '#F1F3F8',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 'PMI_CR',
    elementState: 2,
    containerClass: 'RadialHeaderList_radialFilterComponentContainer__2xTWU',
    disableStrokeColor: '#F1F3F8',
  },
  {
    color: '#004CE4',
    value: 0,
    valueSuffix: 'project',
    supLabelTranslation: 'validation',
    label: 'completed_female',
    percentage: 0,
    trailColor: '#F1F3F8',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 'PMI_VALIDATED',
    elementState: 2,
    containerClass: 'RadialHeaderList_radialFilterComponentContainer__2xTWU',
    disableStrokeColor: '#F1F3F8',
  },
];
